import { findRef } from "./findRef.js";
const findRefByLabel = (refs, label) => {
  return findRef(refs, ref => ref.label === label);
};
export { findRefByLabel };
